// Action Types
export const FETCH_COMMODITIES_STARTED = "FETCH_COMMODITIES_STARTED";
export const FETCH_COMMODITIES_SUCCESS = "FETCH_COMMODITIES_SUCCESS";
export const FETCH_COMMODITIES_ERROR = "FETCH_COMMODITIES_ERROR";

export const POST_COMMODITY_STARTED = "POST_COMMODITY_STARTED";
export const POST_COMMODITY_SUCCESS = "POST_COMMODITY_SUCCESS";
export const POST_COMMODITY_ERROR = "POST_COMMODITY_ERROR";

export const PUT_COMMODITY_STARTED = "PUT_COMMODITY_STARTED";
export const PUT_COMMODITY_SUCCESS = "PUT_COMMODITY_SUCCESS";
export const PUT_COMMODITY_ERROR = "PUT_COMMODITY_ERROR";

export const DELETE_COMMODITY_STARTED = "DELETE_COMMODITY_STARTED";
export const DELETE_COMMODITY_SUCCESS = "DELETE_COMMODITY_SUCCESS";
export const DELETE_COMMODITY_ERROR = "DELETE_COMMODITY_ERROR";

// Data types
export interface CommodityLog {
    old_stock: number
    new_stock: number
    timestamp: string
}
export interface Commodity {
    id?: number
    name: string
    company: string
    order_point: number
    stock: number
    trans_stock: number
    logs?: CommodityLog[]
};
//Reducer State Type
export interface CommoditiesState {
    items: any
    error: any
    isFetching: boolean
}
// Action Data Types
export interface FetchCommoditiesActionStarted {
    type: typeof FETCH_COMMODITIES_STARTED
}
export interface FetchCommoditiesActionSuccess {
    type: typeof FETCH_COMMODITIES_SUCCESS
    commodities  : any
    parents     : number[]
}
export interface FetchCommoditiesActionError {
    type: typeof FETCH_COMMODITIES_ERROR
    error: any
}

export interface PostCommodityStartedAction {
    type: typeof POST_COMMODITY_STARTED
}
export interface PostCommoditySuccessAction {
    type: typeof POST_COMMODITY_SUCCESS
}
export interface PostCommodityErrorAction {
    type: typeof POST_COMMODITY_ERROR
}

export interface PutCommodityStartedAction {
    type: typeof PUT_COMMODITY_STARTED
}
export interface PutCommoditySuccessAction {
    type: typeof PUT_COMMODITY_SUCCESS
}
export interface PutCommodityErrorAction {
    type: typeof PUT_COMMODITY_ERROR
}

export interface DeleteCommodityStartedAction {
    type: typeof DELETE_COMMODITY_STARTED
}
export interface DeleteCommoditySuccessAction {
    type: typeof DELETE_COMMODITY_SUCCESS
}
export interface DeleteCommodityErrorAction {
    type: typeof DELETE_COMMODITY_ERROR
}

export type FetchCommoditiesActionTypes =
 FetchCommoditiesActionStarted
 | FetchCommoditiesActionSuccess
 | FetchCommoditiesActionError 
 | PostCommodityStartedAction
 | PostCommoditySuccessAction
 | PostCommodityErrorAction
 | PutCommodityStartedAction
 | PutCommoditySuccessAction
 | PutCommodityErrorAction
 | DeleteCommodityStartedAction
 | DeleteCommoditySuccessAction
 | DeleteCommodityErrorAction
 ;